import React, { ChangeEvent, useCallback } from "react";
import TextField from "@material-ui/core/TextField";
import Grid from '@material-ui/core/Grid';
import { EditFormProps } from "../components/edit-dialog";
import { SceneFormModel } from "./types";

type SceneFormProps = EditFormProps<SceneFormModel>

const LINK_REGEXP = /https:\/\/www.delaltodigital.com(\/.*)/;

export default function SceneForm({ model: { label, link }, setModel, readOnly }: SceneFormProps) {
  const onSetLabel = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setModel({ link, label: event.target.value });
  }, [ setModel, link ]);

  const onSetLink = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const match = value.match(LINK_REGEXP)
    const newLink = match ? match[1] : value;
    setModel({ label, link: newLink });
  }, [ setModel, label ]);

  return (
      <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              autoFocus
              margin="dense"
              id="label"
              label="Nombre"
              type="text"
              value={label}
              onChange={onSetLabel}
              disabled={readOnly}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              margin="dense"
              id="link"
              label="Link"
              type="text"
              value={link}
              onChange={onSetLink}
              disabled={readOnly}
              fullWidth
            />
          </Grid>
      </Grid>
  );
}
